interface StatCardProps {
  icon: string;
  label: string;
  value: string | number;
  color?: string;
  onClick?: () => void;
}

const defaultColors: Record<string, string> = {
  yellow: 'bg-yellow-100 text-yellow-700',
  purple: 'bg-purple-100 text-purple-700',
  blue: 'bg-blue-100 text-blue-700',
  orange: 'bg-orange-100 text-orange-700',
  green: 'bg-green-100 text-green-700',
  red: 'bg-red-100 text-red-700',
  pink: 'bg-pink-100 text-pink-700',
};

export default function StatCard({ icon, label, value, color = 'blue', onClick }: StatCardProps) {
  const colorClass = defaultColors[color] || color;

  const content = (
    <>
      <span className="text-3xl mb-1 block">{icon}</span>
      <p className="text-2xl font-bold">{value}</p>
      <p className="text-xs opacity-80">{label}</p>
    </>
  );

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={`${colorClass} rounded-2xl p-4 text-center w-full hover:shadow-md transition-all focus:outline-none focus:ring-2 focus:ring-primary`}
      >
        {content}
      </button>
    );
  }

  return (
    <div className={`${colorClass} rounded-2xl p-4 text-center`}>
      {content}
    </div>
  );
}